import React from 'react'

export default function Navbar({
  nextMonth,
  previousMonth,
  onPreviousClick,
  onNextClick,
  className,
  localeUtils
}) {
  const months = localeUtils.getMonths()
  const prev = months[previousMonth.getMonth()]
  const next = months[nextMonth.getMonth()]
  return (
    <div className={className} style={{ fontSize: '.75em' }}>
      <span
        style={{ float: 'left', cursor: 'pointer' }}
        onTouchStart={() => onPreviousClick()}
        onClick={() => onPreviousClick()}
      >
        ← {prev.slice(0, 3)}
      </span>
      <span
        style={{ float: 'right', cursor: 'pointer' }}
        onTouchStart={() => onNextClick()}
        onClick={() => onNextClick()}
      >
        {next.slice(0, 3)} →
      </span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/inputs/Navbar.js